import React from 'react';
import { Row, Col, Space, Typography, Button, Tooltip, Breadcrumb } from 'antd';
import {
  HomeOutlined,
  BankOutlined,
  ReloadOutlined,
  SaveOutlined,
  EyeOutlined,
  EyeInvisibleOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const AccountBalanceHeader = ({
  lastLoadTime,
  hideAmounts,
  onToggleHideAmounts,
  onManualSave,
  onRefresh,
  loading,
  savingData
}) => {
  return (
    <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
      <Col>
        <Breadcrumb style={{ marginBottom: '8px' }}>
          <Breadcrumb.Item href="/dashboard">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>계좌 잔고</Breadcrumb.Item>
        </Breadcrumb>
        <Title level={2} style={{ margin: 0 }}>
          <BankOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
          계좌 잔고 관리
        </Title>
      </Col>
      <Col>
        <Space>
          {lastLoadTime && (
            <Tooltip title={`마지막 업데이트: ${lastLoadTime.toLocaleString()}`}>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                마지막 업데이트 : {lastLoadTime.toLocaleTimeString()}
              </Text>
            </Tooltip>
          )}
          <Tooltip title={hideAmounts ? "자산 금액 보기" : "자산 금액 가리기"}>
            <Button
              icon={hideAmounts ? <EyeOutlined /> : <EyeInvisibleOutlined />}
              onClick={onToggleHideAmounts}
              style={{
                backgroundColor: hideAmounts ? '#faad14' : '#d9d9d9',
                borderColor: hideAmounts ? '#faad14' : '#d9d9d9',
                color: 'white'
              }}
            >
              {hideAmounts ? '보기' : '가리기'}
            </Button>
          </Tooltip>
          <Tooltip title="금일 보유 현황 데이터를 DB에 저장합니다">
            <Button
              icon={<SaveOutlined />}
              onClick={onManualSave}
              loading={savingData}
              style={{ 
                backgroundColor: '#52c41a',
                borderColor: '#52c41a',
                color: 'white'
              }}
            >
              수동 저장
            </Button>
          </Tooltip>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={onRefresh}
            loading={loading}
          >
            전체 새로고침
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

export default AccountBalanceHeader;
